export default __webpack_public_path__ + "locales/sk/DataReassignmentDialog.json?hash=8449cc9cdf298e41e984258606d34e8c";